<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I think there’s supposed to be a book but I’m not sure</h1>
			<div>
				<email-form
						subject="I think there’s supposed to be a book but I’m not sure"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						destination-key="ge"
				></email-form>
			</div>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "SupposedToBeBook",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				course_id: '',
			}
		},

		computed: {
			email_body() {
				return `Hello, My professor said there is a book for course ${this.course_id} and I don’t know what book it is. Can you have someone talk to my professor so I can buy my book?`
			},
		},

		mounted() {
			this.course_id = parseInt(this.$route.params['course_id']);
		}
	}
</script>

<style scoped>

</style>